import React from "react";
import { Grid } from "@material-ui/core";
import {
  ArrayInput,
  FormDataConsumer,
  SimpleFormIterator,
  TextInput,
  required,
  SelectInput,
  BooleanInput,
} from "react-admin";

const validateRequired = required();

export const Checklist = ({
  workFlowSteps,
  source,
  label = false,
  className,
  isDisabled,
}) => {
  return (
    <ArrayInput
      source={source}
      label={label}
      className={className ? className : ""}
      fullWidth
    >
      <SimpleFormIterator disableAdd={isDisabled} disableRemove={isDisabled}>
        <FormDataConsumer>
          {({
            formData, // The whole form data
            scopedFormData, // The data for this item of the ArrayInput
            getSource, // Function to get the valid source inside an ArrayInput. Translates to "inventories.items[].property"
            ...rest
          }) => (
            <Grid container spacing={1}>
              <Grid item xs={12} md={4}>
                <TextInput
                  label="Name"
                  source={getSource("name")}
                  variant="outlined"
                  fullWidth
                  validate={validateRequired}
                  helperText={false}
                  disabled={isDisabled}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <SelectInput
                  label="Step Name"
                  source={getSource("stepName")}
                  variant="outlined"
                  fullWidth
                  choices={workFlowSteps}
                  validate={validateRequired}
                  helperText={false}
                  disabled={isDisabled}
                />
              </Grid>
              <Grid item xs={4}>
                <BooleanInput
                  label="Required"
                  source={getSource("isRequired")}
                  helperText={false}
                  disabled={isDisabled}
                />
              </Grid>
              <Grid item xs={12}>
                <TextInput
                  source={getSource("description")}
                  label="Description"
                  variant="outlined"
                  multiline
                  fullWidth
                  validate={validateRequired}
                  helperText={false}
                  disabled={isDisabled}
                />
              </Grid>
            </Grid>
          )}
        </FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  );
};
